import { AuthClient } from "@meistrari/auth-core";
import { version } from "../../package.json";
export function createNuxtAuthClient(apiUrl, getAuthToken) {
  const serviceName = typeof process !== "undefined" ? process.env.SERVICE_NAME : "";
  const userAgent = `auth-sdk:nuxt:${version}${serviceName ? `@${serviceName}` : ""}`;
  return new AuthClient(apiUrl, {
    headers: {
      "X-User-Agent": userAgent
    },
    onRequest: (context) => {
      const requestUrl = new URL(context.url);
      const token = getAuthToken();
      const isTokenRequest = requestUrl.pathname.endsWith("/api/auth/token");
      if (token && !isTokenRequest) {
        context.headers.set("Authorization", `Bearer ${token}`);
      }
    }
  });
}
